import { createGlobalStyle } from 'styled-components';
import { breakpoints } from './breakpoints';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    max-width: 100vw;
    overflow-wrap: break-word;
    word-wrap: break-word;
  }

  body {
    font-family: 'Source Serif 4', Georgia, 'Times New Roman', serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #FAF6ED;
    color: #2A1F0E;
    line-height: 1.6;
    overflow-x: hidden;
    width: 100%;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    line-height: 1.2;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
  }

  /* Custom scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #FAF6ED;
  }

  ::-webkit-scrollbar-thumb {
    background: #C9952A;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #9A6F1A;
  }

  html {
    @media (max-width: ${breakpoints.mobile}) {
      font-size: 14px;
    }
  }

  h1 {
    @media (max-width: ${breakpoints.tablet}) {
      font-size: 2.5rem;
    }
    @media (max-width: ${breakpoints.mobile}) {
      font-size: 2rem;
    }
  }

  h2 {
    @media (max-width: ${breakpoints.tablet}) {
      font-size: 2rem;
    }
    @media (max-width: ${breakpoints.mobile}) {
      font-size: 1.75rem;
    }
  }
`;

export default GlobalStyles; 